import HasErrorsMixin from './HasErrorsMixin';

export default {
  mixins: [
    HasErrorsMixin
  ],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    errors: {
      type: Array,
      default: undefined
    },

    isNew: {
      type: Boolean,
      default: false
    },

    value: {
      type: Object,
      required: true
    },
  },

  methods: {
    propertyChange(name, value) {
      const ret = { ...this.value };
      //console.log('propertyChange', name, ret[name], '->', value);
      ret[name] = value;
      this.$emit('input', ret);
    },

    propertiesChange(fixes = {}) {
      const ret = { ...this.value };
      //console.log('propertyChange', name, ret[name], '->', value);
      for (let name of Object.keys(fixes)) {
        ret[name] = fixes[name];
      }
      this.$emit('input', ret);
    },

    setProperty(name, index, value) {
      const newArray = [ ...this.value[name] ];
      newArray[index] = value;
      this.propertyChange(name, newArray);
    },

    pushItem(name, value) {
      const ret = { ...this.value };
      const oldArray = ret[name];
      const newArray = [ ...oldArray, value ];
      ret[name] = newArray;
      this.$emit('input', ret);
    }
  }
};
